export enum MaritalStatus{
  Married='Married',
  UnMarried='Un-Married'
}